// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_dotsLoader__klF0Y {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 32px 4px;
}

.styles_dot__ET3YH {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--color-blue-light);
  animation: styles_dotPulse__gcqDz 1.5s ease-in-out infinite;
}
@media (min-width: 768px) {
  .styles_dot__ET3YH {
    width: 12px;
    height: 12px;
  }
}

.styles_dot1__Uj-vq {
  animation-delay: 0s;
}

.styles_dot2__n15XU {
  animation-delay: 0.3s;
}

.styles_dot3__fzntJ {
  animation-delay: 0.6s;
}

.styles_dot4__Cpktm {
  animation-delay: 0.9s;
}

@keyframes styles_dotPulse__gcqDz {
  0%, 100% {
    background-color: var(--color-blue-light);
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    background-color: var(--color-accent-blue);
    transform: scale(1.2);
    opacity: 1;
  }
}
.styles_infoMessage__gLdcy {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 0px;
  color: #4285F4;
  font-size: 16px;
  padding: 0 16px;
  text-align: center;
}
.styles_infoMessage__gLdcy .styles_infoIcon__dfk8V {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.styles_infoMessage__gLdcy span {
  opacity: 0.8;
}
@media (max-width: 480px) {
  .styles_infoMessage__gLdcy {
    font-size: 14px;
    gap: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/loading/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,2DAAA;AAAF;ACPE;EDEF;IAQI,WAAA;IACA,YAAA;EACF;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE;IACE,yCAAA;IACA,mBAAA;IACA,YAAA;EACF;EACA;IACE,0CAAA;IACA,qBAAA;IACA,UAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAAJ;AAGE;EACE,YAAA;AADJ;AAKE;EAtBF;IAuBI,eAAA;IACA,QAAA;EAFF;AACF","sourcesContent":["@import \"mixins\";\n.dotsLoader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 32px 4px;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: var(--color-blue-light);\n  animation: dotPulse 1.5s ease-in-out infinite;\n\n  @include md {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n.dot1 {\n  animation-delay: 0s;\n}\n\n.dot2 {\n  animation-delay: 0.3s;\n}\n\n.dot3 {\n  animation-delay: 0.6s;\n}\n\n.dot4 {\n  animation-delay: 0.9s;\n}\n\n@keyframes dotPulse {\n  0%, 100% {\n    background-color: var(--color-blue-light);\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  50% {\n    background-color: var(--color-accent-blue);\n    transform: scale(1.2);\n    opacity: 1;\n  }\n}\n\n.infoMessage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin-top: 0px;\n  color: #4285F4;\n  font-size: 16px;\n  padding: 0 16px;\n  text-align: center;\n\n  .infoIcon {\n    width: 16px;\n    height: 16px;\n    flex-shrink: 0;\n  }\n\n  span {\n    opacity: 0.8;\n  }\n\n  // Mobile: smaller text\n  @media (max-width: 480px) {\n    font-size: 14px;\n    gap: 6px;\n  }\n}\n","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dotsLoader": `styles_dotsLoader__klF0Y`,
	"dot": `styles_dot__ET3YH`,
	"dotPulse": `styles_dotPulse__gcqDz`,
	"dot1": `styles_dot1__Uj-vq`,
	"dot2": `styles_dot2__n15XU`,
	"dot3": `styles_dot3__fzntJ`,
	"dot4": `styles_dot4__Cpktm`,
	"infoMessage": `styles_infoMessage__gLdcy`,
	"infoIcon": `styles_infoIcon__dfk8V`
};
export default ___CSS_LOADER_EXPORT___;
